module.exports = __webpack_public_path__ + "static/img/text_home.f4d5df00.png";